import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-19e1a223"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "auth" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_card = _resolveComponent("v-card")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_v_card, {
      variant: "outlined",
      width: "400",
      class: "auth__card"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_card_title, { class: "auth__card__title" }, {
          default: _withCtx(() => [
            _createTextVNode(" English Conversation Transcriber ")
          ]),
          _: 1
        }),
        _createVNode(_component_v_card_text, { class: "auth__card__text" }, {
          default: _withCtx(() => [
            _createVNode(_component_v_row, null, {
              default: _withCtx(() => [
                _createVNode(_component_v_col, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_btn, {
                      class: "auth__card__text__btn",
                      onClick: _ctx.authWithGoogle,
                      variant: "outlined"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_icon, { class: "auth__card__text__btn__icon" }, {
                          default: _withCtx(() => [
                            _createTextVNode("mdi-google")
                          ]),
                          _: 1
                        }),
                        _createTextVNode(" Sign in with Google ")
                      ]),
                      _: 1
                    }, 8, ["onClick"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_col, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_btn, {
                      class: "auth__card__text__btn",
                      onClick: _ctx.authWithGoogle,
                      variant: "outlined"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_icon, { class: "auth__card__text__btn__icon" }, {
                          default: _withCtx(() => [
                            _createTextVNode("mdi-account-plus")
                          ]),
                          _: 1
                        }),
                        _createTextVNode(" Sign up with Google ")
                      ]),
                      _: 1
                    }, 8, ["onClick"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ]))
}